import { Component, OnInit, Input, ElementRef, ContentChild, TemplateRef, HostBinding, forwardRef } from '@angular/core';
import { CfSelectableComponent } from '../selectable/selectable.component';
import { SelectableModel } from '../../models/selectable/selectable.model';
import { SelectableStylingModel } from '../../models/selectable/selectable-styling.model';
import { SwitchTemplates } from '../../templates/switch.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Switch Component</p>
 * <pre>
 * <code>
 * import {{'{'}} SelectableModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} SelectableStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-switch<code>></code><code><</code><code>/</code>cf-switch<code>></code>
 * </code>
 * </pre>
 */
export class CfSwitchComponent extends CfSelectableComponent implements OnInit {
/**
 * @hidden
 */
notificationClickable = '';
/**
 * @hidden
 */
cfSwitchTemplate;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new SelectableModel();
    this.styling = new SelectableStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('switch', SwitchTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'SWITCH').then( sampler => {
        this.checked = this.properties.checked;
        if (this.notificationAction.observers.length > 0) { this.notificationClickable = 'notification-clickable'; }
        // console.log('SWITCH', this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-switch',
  template: "<cf-selectable> <div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-selectable'\"> <div class=\"cf-switch-group-container {{properties?.labelPosition}}\" [class.has-no-item]=\"hasNoItem\"> <md-slide-toggle class=\"{{activeTemplate.style?.button?.class}} {{styling?.button?.class}} {{getDynamicClasses(activeTemplate.style?.button?.dynamicClass)}} {{getDynamicClasses(styling?.button?.dynamicClass)}}\" [ngClass]=\"'cf-switch'\"[(ngModel)]=\"checked\" (click)=\"notifyGroup()\" [(checked)]=\"checked\" [disabled]=\"properties?.disable\" [labelPosition]=\"properties?.itemPosition || 'after'\" [color]=\"styling?.button?.themeColor || activeTemplate.style?.button?.themeColor\"> <div *ngIf=\"!cfSwitchTemplate && !!properties?.item\" [innerHtml]=\"properties?.item | safePipe\"></div> <div *ngIf=\"cfSwitchTemplate\" [ngTemplateOutlet]=\"cfSwitchTemplate\" [ngOutletContext]=\"{cfIndex: i, cfItem: properties?.item}\"></div> </md-slide-toggle> </div> <cf-notification *ngIf=\"notification && (notification?.value || notification?.icon)\" [settings]=\"notification\" (click)=\"cfNotificationAction(notification)\"></cf-notification> </div> </cf-selectable>",
  styles: [":host { position: relative; z-index: 0; display: inline-flex; } :host.notification-clickable cf-notification:hover { cursor: pointer; } .cf-switch-group-container { display: inline-flex; flex-direction: column; } :host /deep/ md-slide-toggle { height: auto; margin: 2px 0; } :host /deep/ md-slide-toggle .mat-slide-toggle-label { align-items: center; } :host /deep/ md-slide-toggle .mat-slide-toggle-label .mat-disabled * { color: #b0b0b0; } :host /deep/ md-slide-toggle.mat-slide-toggle-label-before .mat-slide-toggle-label { justify-content: flex-end; } :host /deep/ .mat-slide-toggle-content { font: inherit; } :host /deep/ .has-no-item .mat-slide-toggle-bar { margin-left: 0px; margin-right: 0px; } [hidden] { display: none !important; } "],
  providers: [{ provide: CfSelectableComponent, useExisting: forwardRef(() => CfSwitchComponent) }]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notificationClickable': [{ type: HostBinding, args: ['class', ] },],
'cfSwitchTemplate': [{ type: ContentChild, args: [TemplateRef, ] },],
};
}

function CfSwitchComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfSwitchComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfSwitchComponent.ctorParameters;
/** @type {?} */
CfSwitchComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfSwitchComponent.prototype.notificationClickable;
/**
 * @hidden
 * @type {?}
 */
CfSwitchComponent.prototype.cfSwitchTemplate;
/**
 * @hidden
 * @type {?}
 */
CfSwitchComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
